
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>

				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="List" placeholder="姓名"></el-input>
				</el-form-item>
				<!-- <el-form-item>
					<el-input  v-model="filters.CardNumber"  @keyup.enter.native="List" placeholder="卡号"></el-input>
				</el-form-item>                 -->
                <el-form-item>
                    <div class="block">
                   <el-date-picker
				   placeholder="选择日期"
                        v-model="filters.dateValue" 
                         type="daterange"                       
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                   </el-date-picker>
                    </div>
                   </el-form-item>					
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="List" icon="el-icon-search">查询</el-button>
					<el-button size="width:100%; height:100%;" type="warning" :loading="reportLoading" v-on:click="exportReport" icon="el-icon-search">导出</el-button>

				</el-form-item>
				<!-- <el-form-item>
					<el-button size="width:100%; height:100%;" type="warning"  v-on:click="exportReport" icon="el-icon-search">导出充值总计</el-button>					
				</el-form-item>			 -->
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="ListData" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column prop="CardNumber" label="卡号" width="250" sortable>
			</el-table-column> -->
			<el-table-column prop="Name" label="姓名" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Height" label="身高" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Weight" label="体重" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="StyleName" label="泳姿" width="120" sortable>
			</el-table-column>	
			<el-table-column prop="Time" label="时长" width="120" sortable>
			</el-table-column> 
			<el-table-column prop="Distance" label="距离" width="120" sortable>
			</el-table-column>            						
			<el-table-column prop="Heat" label="热量" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Frequency" label="划水次数" width="120" sortable>
			</el-table-column>
						<el-table-column prop="Length" label="泳池长度" width="120" sortable>
			</el-table-column>
						<el-table-column prop="PaceStr" label="配速/100米" width="130" sortable>
			</el-table-column>
						<!-- <el-table-column prop="Number" label="趟数" width="120" sortable>
			</el-table-column>
						<el-table-column prop="Heat" label="热量" width="200" sortable>
			</el-table-column>
						<el-table-column prop="Heat" label="热量" width="200" sortable>
			</el-table-column>
						<el-table-column prop="Heat" label="热量" width="200" sortable>
			</el-table-column>	
					<el-table-column prop="Heat" label="热量" width="200" sortable>
			</el-table-column>			 -->

            <el-table-column prop="CreationTime" label="提交时间" min-width="200" sortable>
			</el-table-column>	
			<el-table-column  label="提交截图" width="120" sortable>
				<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img v-if="scope.row.ImageUrl!=null"  @click="see(scope.row.ImageUrl)"  :src="scope.row.ImageUrl" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
                    </el-tooltip>
				</template>				
			</el-table-column>								
<!--       
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column> -->
			<el-table-column prop="State" label="状态" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==0">未处理</el-tag>
                  <el-tag type="danger" size="medium" v-if="scope.row.State==1">拒绝</el-tag>
                  <el-tag type="success" size="medium" v-if="scope.row.State==2">通过</el-tag>
                  </div>
                  </template>
			</el-table-column>            
			<el-table-column label="操作" width="100" fixed="right">
				<template  slot-scope="scope">
                    <!-- 两小时可撤单 -->
					<el-button v-if="scope.row.State==2" type="danger" size="small" @click="UnPass(scope.row)">取消通过</el-button>
					<el-button v-if="scope.row.State==1||scope.row.State==0" type="success" size="small" @click="Pass( scope.row)">通过</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbarfoot">

			<el-pagination class="toolbarfoot" layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--编辑界面-->
		<!-- <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm" @submit.native.prevent>							
				<el-form-item label="手牌刷卡号" prop="Number">
					<el-input v-model="editForm.Number" auto-complete="off"></el-input>
				</el-form-item>				
			    <el-form-item label="对应柜号" prop="CabinetNumber">
					<el-input  v-model="editForm.CabinetNumber" auto-complete="off"></el-input>
				</el-form-item>            		
                		
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>	
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog> -->

		<!--新增界面-->
		<!-- <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item label="手牌刷卡号" prop="Number">
					<el-input v-model="addForm.Number" auto-complete="off"></el-input>
				</el-form-item>				
			    <el-form-item label="对应柜号" prop="CabinetNumber">
					<el-input  v-model="addForm.CabinetNumber" auto-complete="off"></el-input>
				</el-form-item>		                		
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog> -->
  <!-- 重置界面 -->
  	        <el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../../common/js/util'

	//import NProgress from 'nprogress'
	import {SwimmingDataExportData,SetStatePass,SetStateUnPass, RechargeRecordCancel,SwimmingDataPage, removeRechargeRecord } from '../../../api/api';

	export default {
		data() {
			return {
				reportLoading:false,
				filters: {
					Name: '',
					ShopName:'',
					dateValue: ''					
				},
				imgUrl:'',
				seeImageVisible:false,
				imageUrl:'',				
                radio:'0',
		       Loading:false,
				Count:0,
				options:[],
				ListData:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
			}
		},
		methods: {
		exportReport()
			{
				this.reportLoading=true;
			    let para = {
					Name:this.filters.Name,
					ShopName:this.filters.ShopName,
					StartDate:this.filters.dateValue.length>0?this.filters.dateValue[0]:'',
					EndDate:this.filters.dateValue.length>0?this.filters.dateValue[1]:'' 	
					};
  				let downloadName="游泳数据";
				 SwimmingDataExportData(para).then((res)=>{						 
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = downloadName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
						 this.reportLoading=false;
					 }
					 else
					 {
						 this.reportLoading=false;
					 }
		   })
			},								
			see(Image){
                     this.imgUrl=Image;
                  this.seeImageVisible=true;
              },			
			Pass(row){
                 let para={
                    id:row.Id
                }
              SetStatePass(para).then((res)=>{
						let { Success } = res.data;
						if(Success){
				        row.State=res.data.Data
						}				  
              }).catch(error=>{
                 alert('网络错误');
                });              
			},
			UnPass(row){
                 let para={
                    id:row.Id
                }
              SetStateUnPass(para).then((res)=>{
						let { Success } = res.data;
						if(Success){
				        row.State=res.data.Data
						}				  
              }).catch(error=>{
                 alert('网络错误');
                });   
			},
			Cancel: function (index, row) {
				this.$confirm('确认撤销这笔充值吗?', '提示', {
					type: 'warning'
				}).then(() => {

					let State=row.State;
					if(State==1)
					{
						this.$message({
							message: '已撤销不能再次撤销',
							type: 'error'
						});

					}
					else
					{	

							
                        let para={
                         id:row.Id
                        }
                        RechargeRecordCancel(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: Msg,
							type: 'success'
						});
						 row.State=row.State==1?0:1;			 
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}                       
						       }).catch(error=>{
                                 alert('网络错误');
                                 });									
				           	}

				}).catch(() => {

				});
			},			
            formatType: function (row, column) {
				return row.MachineType == 1 ? '箱柜' :  '闸机' ;
			},
           SwitchChange(row){
                // console.log(1);
			   row.State=row.BoolState==true?0:1;			 
                let para={
                    id:row.Id
                }
              TicketChangeState(para).then((res)=>{
              }).catch(error=>{
                 alert('网络错误');
                });
            },
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			// formatState: function (row, column) {
			// 	return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			// },
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.List();
			},
			//获取用户列表
		
			List() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					StartDate:this.filters.dateValue.length>0?this.filters.dateValue[0]:'',
					EndDate:this.filters.dateValue.length>0?this.filters.dateValue[1]:'' 							
					// CardNumber:this.filters.CardNumber
				};
				this.listLoading = true;
				//NProgress.start();
				SwimmingDataPage(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.ListData =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeRechargeRecord(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.List();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.List();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// SwimmingData.vue?008c0eb4